export default "__VITE_ASSET__BGIg$o0J__"